import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

function safeTrim(value) {
    return value != null ? String(value).trim() : '';
}

export default async function PutArticle(
        clientUuid, 
        data
    ) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/article/' +  data.uuid + "?clientUuid=" + clientUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "articleName": safeTrim(data.naziv),
                "unitOfMeasure": safeTrim(data.jed_mjera),
                "catalogNumber": safeTrim(data.kataloski_broj),
                "articleCode": safeTrim(data.sifra),
                "additionalName": safeTrim(data.dodatni_naziv),
                "unitQuantity": safeTrim(data.jed_kolicina),
                "taxRate": safeTrim(data.porez)
            }
        }).then(
            res => (res)
        )
        .catch(error => error.response.data),
        "Admin"        
    )
}